import React from "react";

export default function WatchIcon() {
  return (
    <svg
      width="40"
      height="35"
      viewBox="0 0 40 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.5888 30.4564L22.6573 1.51416C22.1091 0.577125 21.0963 0 20 0C18.9039 0 17.8909 0.577005 17.3428 1.51416L0.411303 30.4564C-0.13706 31.3935 -0.13706 32.5483 0.41106 33.4855C0.95918 34.4226 1.97216 35 3.06852 35H36.9316C38.0278 35 39.0409 34.4228 39.589 33.4855C40.137 32.5483 40.137 31.3935 39.5888 30.4564ZM3.06852 31.9711L20 3.0288L36.9316 31.9711H3.06852Z"
        fill="#E24444"
      />
      <path
        d="M17.8764 13.4551L18.7563 23.3993C18.8077 23.9847 19.2784 24.4672 19.8918 24.5201C20.5789 24.5794 21.1845 24.0775 21.2445 23.3993L22.1244 13.4551C22.1339 13.3389 22.1351 13.2086 22.1244 13.0888C22.022 11.9307 20.988 11.0741 19.8149 11.1751C18.6419 11.2763 17.7739 12.2972 17.8764 13.4551Z"
        fill="#E24444"
      />
      <path
        d="M19.9992 28.6112C20.9711 28.6112 21.7591 27.8334 21.7591 26.874C21.7591 25.9145 20.9711 25.1367 19.9992 25.1367C19.0272 25.1367 18.2393 25.9145 18.2393 26.874C18.2393 27.8334 19.0272 28.6112 19.9992 28.6112Z"
        fill="#E24444"
      />
    </svg>
  );
}
